<div class="row">
  <div class="col-md-12">
    
    <!-- Wybór okresu -->
    <div class="row mb-3">
      <div class="col-md-12">
        <nb-card>
          <nb-card-body>
            <section>
              <span>{{ 'akcja.wybierz-okres' | translate }}:</span>
            </section>
            <section class="mt-2 ml-3">
              <ngx-zakres-dat [skipLocalStorage]="true" (zmianaZakresu)="onChangeZmianaZakresu($event)"></ngx-zakres-dat>
            </section>
          </nb-card-body>
        </nb-card>
      </div>
    </div>

    <!-- Tabele -->
    <div class="row">
      <div class="col-md-6">
        <nb-card>
          <nb-card-header>{{ 'tytul.rozliczenie-podatkow' | translate }}</nb-card-header>
          <nb-card-body>
            <ngx-podatki-tabela [dane]="podatkiData" [zakresDat]="zakresDat"></ngx-podatki-tabela>
            
            <!-- Informacja o rachunku podatkowym -->
            <div class="mt-3 pt-3 border-top" *ngIf="klientData && klientData.numerRachunkuPodatki">
              <div class="bank-account-info">
                <span class="bank-account-text">
                  <span>{{ 'komunikat.rachunek-podatkowy-text' | translate }}</span>
                  <span class="account-number">{{ klientData.numerRachunkuPodatki }}</span>
                </span>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-md-6">
        <nb-card>
          <nb-card-header>{{ 'tytul.rozliczenie-zus' | translate }}</nb-card-header>
          <nb-card-body>
            <ngx-zus-tabela [dane]="zusData" [zakresDat]="zakresDat"></ngx-zus-tabela>
            
            <!-- Informacja o rachunku ZUS -->
            <div class="mt-3 pt-3 border-top" *ngIf="klientData && klientData.numerRachunkuZUS">
              <div class="bank-account-info">
                <span class="bank-account-text">
                  <span>{{ 'komunikat.rachunek-zus-text' | translate }}</span>
                  <span class="account-number">{{ klientData.numerRachunkuZUS }}</span>
                </span>
              </div>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </div>
    
  </div>
</div>